import React, { useEffect, useState } from "react";
import "./Navbar.css";

import { useSelector } from "react-redux";

import logo from "../../Assets/logo.png";
import logo1 from "../../Assets/RedAndBlack.webp";
import { Link, useNavigate } from "react-router-dom";

import { RiMenu2Line } from "react-icons/ri";
import { FiSearch } from "react-icons/fi";
import { FaRegUser } from "react-icons/fa6";
import { RiShoppingBagLine } from "react-icons/ri";
import { MdOutlineClose } from "react-icons/md";
import { FiHeart } from "react-icons/fi";
import { FaFacebookF } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaInstagram } from "react-icons/fa";
import { FaYoutube } from "react-icons/fa";
import { FaPinterest } from "react-icons/fa";

import Badge from "@mui/material/Badge";
import { useAuth } from "../../Auth/AuthContext";

const Navbar = () => {
  const { userInfo, setUserInfo } = useAuth();
  const cart = useSelector((state) => state.cart);
  // const [userInfo, setUserInfo] = useState(null);
  const [showDropdown, setShowDropdown] = useState(false);
  const navigate = useNavigate();


  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
    document.body.style.overflow = mobileMenuOpen ? "auto" : "hidden";
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  useEffect(() => {
    const storedUser = localStorage.getItem("userInfo");
    if (storedUser) {
      setUserInfo(JSON.parse(storedUser));
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("userInfo");
    setUserInfo(null);
    navigate("/loginSignUp");
  };


  return (
    <>
      {/* Desktop Menu */}
      <nav className="navBar">
        <div className="logoLinkContainer">
          <div className="logoContainer">
            <Link to="/" onClick={scrollToTop}>
              <img src={logo1} alt="Logo" />
            </Link>
          </div>
          <div className="linkContainer">
            <ul>
              <li>
                <Link to="/" onClick={scrollToTop}>
                  HOME
                </Link>
              </li>
              {/* <li>
                <Link to="/shop" onClick={scrollToTop}>
                  SHOP
                </Link>
              </li> */}
              <li>
                <Link to="/blog" onClick={scrollToTop}>
                  BLOG
                </Link>
              </li>
              <li>
                <Link to="/about" onClick={scrollToTop}>
                  ABOUT
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={scrollToTop}>
                  CONTACT
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="iconContainer">
          <FiSearch size={22} onClick={scrollToTop} />
          {/* <Link to="/loginSignUp" onClick={scrollToTop}>
            <FaRegUser size={22} />
          </Link> */}
          {/* <div style={{ position: "relative" }}>
            {!userInfo ? (
              <Link to="/loginSignUp" onClick={() => window.scrollTo(0, 0)}>
                <FaRegUser size={22} />
              </Link>
            ) : (
              <div
                onClick={() => setShowDropdown(!showDropdown)}
                style={{ cursor: "pointer" }}
              >
                👤 {userInfo.user?.name || "User"}
                {showDropdown && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      right: 0,
                      backgroundColor: "white",
                      boxShadow: "0px 2px 8px rgba(0,0,0,0.1)",
                      zIndex: 999,
                    }}
                  >
                    <ul
                      style={{ listStyle: "none", margin: 0, padding: "10px" }}
                    >
                      <li>
                        <Link
                          to="/profile"
                          onClick={() => setShowDropdown(false)}
                        >
                          Profile
                        </Link>
                      </li>
                      <li>
                        <Link
                          to="/orders"
                          onClick={() => setShowDropdown(false)}
                        >
                          Order List
                        </Link>
                      </li>
                      <li>
                        <button
                          onClick={handleLogout}
                          style={{
                            background: "none",
                            border: "none",
                            cursor: "pointer",
                          }}
                        >
                          Logout
                        </button>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            )}
          </div> */}
          {/* <div style={{ position: "relative" }}>
            {!userInfo ? (
              <Link to="/loginSignUp" onClick={() => window.scrollTo(0, 0)}>
                <FaRegUser size={22} />
              </Link>
            ) : (
              <div
                onClick={() => setShowDropdown(!showDropdown)}
                style={{ cursor: "pointer" }}
              >
                👤 {userInfo.user?.name || "User"}
                {showDropdown && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      right: 0,
                      backgroundColor: "#DCDCDC",
                      width: "130px",
                      height: "120px",
                    }}
                  >
                    <ul
                      style={{
                        listStyle: "none",
                        margin: 0,
                        padding: "20px",
                        textAlign: "center",
                      }}
                    >
                      <li
                        style={{
                          borderBottom: "1px solid gray",
                          gap: "10px",
                          marginTop: 5,
                        }}
                      >
                        <Link to="/profile">Profile</Link>
                      </li>
                      <li
                        style={{
                          borderBottom: "1px solid gray",
                          gap: "10px",
                          marginTop: 5,
                        }}
                      >
                        <Link to="/orders">My Orders</Link>
                      </li>
                      <li
                        style={{
                          borderBottom: "1px solid gray",
                          gap: "10px",
                          marginTop: 5,
                        }}
                      >
                        <p onClick={handleLogout}>Logout</p>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            )}
          </div> */}
          <div style={{ position: "relative" }}>
            {!userInfo ? (
              <Link to="/loginSignUp" onClick={() => window.scrollTo(0, 0)}>
                <FaRegUser size={22} />
              </Link>
            ) : (
              <div
                onClick={() => setShowDropdown(!showDropdown)}
                style={{ cursor: "pointer" }}
              >
                👤 {userInfo.user?.name || "User"}
                {showDropdown && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      right: 0,
                      backgroundColor: "#DCDCDC",
                      width: "150px",
                      minHeight: "150px",
                    }}
                  >
                    <ul
                      style={{
                        listStyle: "none",
                        margin: 0,
                        padding: "20px",
                        textAlign: "center",
                      }}
                    >
                      <li
                        style={{
                          borderBottom: "1px solid gray",
                          gap: "10px",
                          marginTop: 5,
                        }}
                      >
                        <Link to="/profile">Profile</Link>
                      </li>
                      <li
                        style={{
                          borderBottom: "1px solid gray",
                          gap: "10px",
                          marginTop: 5,
                        }}
                      >
                        <Link to="/orders">My Orders</Link>
                      </li>

                      {/* ✅ Show Dashboard only if user is Admin */}
                      {userInfo.user?.role === 1 && (
                        <li
                          style={{
                            borderBottom: "1px solid gray",
                            gap: "10px",
                            marginTop: 5,
                          }}
                        >
                          <Link to="/admin">Dashboard</Link>
                        </li>
                      )}

                      <li
                        style={{
                          gap: "10px",
                          marginTop: 5,
                        }}
                      >
                        <p onClick={handleLogout}>Logout</p>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            )}
          </div>

          <Link to="/cart" onClick={scrollToTop}>
            <Badge
              badgeContent={cart.items.length === 0 ? "0" : cart.items.length}
              color="primary"
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
            >
              <RiShoppingBagLine size={22} />
            </Badge>
          </Link>
          <FiHeart size={22} onClick={scrollToTop} />
          {/* <RiMenu2Line size={22} /> */}
        </div>
      </nav>

      {/* Mobile Menu */}
      <nav>
        <div className="mobile-nav">
          {mobileMenuOpen ? (
            <MdOutlineClose size={22} onClick={toggleMobileMenu} />
          ) : (
            <RiMenu2Line size={22} onClick={toggleMobileMenu} />
          )}
          <div className="logoContainer">
            <Link to="/">
              <img src={logo} alt="Logo" />
            </Link>
          </div>
          <Link to="/cart">
            <Badge
              badgeContent={cart.items.length === 0 ? "0" : cart.items.length}
              color="primary"
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
            >
              <RiShoppingBagLine size={22} color="black" />
            </Badge>
          </Link>
        </div>
        <div className={`mobile-menu ${mobileMenuOpen ? "open" : ""}`}>
          <div className="mobile-menuTop">
            <div className="mobile-menuSearchBar">
              <div className="mobile-menuSearchBarContainer">
                <input type="text" placeholder="Search products" />
                <Link to="/">
                  <FiSearch size={22} onClick={toggleMobileMenu} />
                </Link>
              </div>
            </div>
            <div className="mobile-menuList">
              <ul>
                <li>
                  <Link to="/" onClick={toggleMobileMenu}>
                    HOME
                  </Link>
                </li>
                {/* <li>
                  <Link to="/shop" onClick={toggleMobileMenu}>
                    SHOP
                  </Link>
                </li> */}
                <li>
                  <Link to="/blog" onClick={toggleMobileMenu}>
                    BLOG
                  </Link>
                </li>
                <li>
                  <Link to="/about" onClick={toggleMobileMenu}>
                    ABOUT
                  </Link>
                </li>
                <li>
                  <Link to="/contact" onClick={toggleMobileMenu}>
                    CONTACT
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="mobile-menuFooter">
            <div className="mobile-menuFooterLogin">
              <Link to="/loginSignUp" onClick={toggleMobileMenu}>
                <FaRegUser />
                <p>My Account</p>
              </Link>
            </div>
            <div className="mobile-menuFooterLangCurrency">
              <div className="mobile-menuFooterLang">
                <p>Language</p>
                <select name="language" id="language">
                  <option value="english">United States | English</option>
                  <option value="Hindi">Hindi</option>
                  <option value="Germany">Germany</option>
                  <option value="French">French</option>
                </select>
              </div>
              <div className="mobile-menuFooterCurrency">
                <p>Currency</p>
                <select name="currency" id="currency">
                  <option value="USD">$ USD</option>
                  <option value="INR">₹ INR</option>
                  <option value="EUR">€ EUR</option>
                  <option value="GBP">£ GBP</option>
                </select>
              </div>
            </div>
            <div className="mobile-menuSocial_links">
              <FaFacebookF />
              <FaXTwitter />
              <FaInstagram />
              <FaYoutube />
              <FaPinterest />
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navbar;
